import React from "react";
import "./Testimonials.scss";

const testimonials = [
  {
    text: "Encontré todo para los XV de mi hija en un solo lugar. Fue mucho más fácil organizar todo de lo que imaginaba.",
    name: "María López",
    role: "Mamá de quinceañera",
  },
  {
    text: "Me encantó poder ver ideas y proveedores en un solo sitio. Me ayudó muchísimo a decidir cómo quería mi fiesta.",
    name: "Andrea Martínez",
    role: "Quinceañera",
  },
  {
    text: "Ahorra muchísimo tiempo. Antes buscaba en muchos lugares, aquí encontré todo mucho más rápido.",
    name: "Carlos Hernández",
    role: "Papá de quinceañera",
  },
];

const Testimonials = () => {
  return (
    <section className="testimonialsDreams">
      <div className="container">
        <div className="testimonialsDreams__header">
          <span className="testimonialsDreams__tag">Experiencias reales</span>

          <h2>Lo que dicen sobre Dreams XV</h2>

          <p>
            Familias y quinceañeras que ya comenzaron a planear su evento con
            Dreams XV comparten su experiencia.
          </p>
        </div>

        <div className="testimonialsDreams__slider">
          {testimonials.map((item, index) => (
            <article className="testimonialsDreams__card" key={index}>
              <div className="testimonialsDreams__stars">★★★★★</div>

              <p className="testimonialsDreams__text">“{item.text}”</p>

              <div className="testimonialsDreams__user">
                <strong>{item.name}</strong>
                <span>{item.role}</span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;